/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 14:59:13 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { DeleteButton, SaveButton, Toolbar } from 'react-admin';
import { toolbarStyles } from 'styles';

const SanitizedDeleteButton = ({ onSave, ...rest }) => (
  <DeleteButton {...rest} />
);

const SaveDeleteToolbar = props => {
  const {
    hideDelete = false,
    className,
    onSave,
    redirect,
    deleteRedirect = 'list',
    ...rest
  } = props;
  const classes = toolbarStyles();
  return (
    <Toolbar className={classes.root} {...rest}>
      <SaveButton redirect={redirect} />
      {hideDelete ? null : (
        <SanitizedDeleteButton redirect={deleteRedirect} undoable={false} />
      )}
    </Toolbar>
  );
};

export default SaveDeleteToolbar;
